import React, { useRef } from "react";
import styles from "../../../css/ai-mode/chat-input/chat-input.module.css"

interface ChatInputProps {
  value: string;
  onChange: (val: string) => void;
  onSend: () => void;
}

const ChatInput: React.FC<ChatInputProps> = ({ value, onChange, onSend }) => {
  const inputRef = useRef<HTMLTextAreaElement>(null);

  const autoGrow = (element: HTMLTextAreaElement) => {
    if (!element) return;
    element.style.height = "auto";
    element.style.height = `${element.scrollHeight}px`;
  };

  return (
    <div className={styles.inputBar}>
      <textarea
        ref={inputRef}
        placeholder="Type your question here..."
        className={styles.aiInput}
        value={value}
        onChange={(e) => {
          onChange(e.target.value);
          autoGrow(e.target);
        }}
        rows={1}
        onKeyDown={(e) => {
          if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            onSend();
          }
        }}
      />
      <button className={styles.aiSendButton} onClick={onSend}>
        Send
      </button>
    </div>
  );
};

export default ChatInput;
